export const stats = [
  {
    value: '5',
    label: 'Total Downloads',
    sub: 'Players worldwide',
    suffix: 'M+',
    prefix: ''
  },
  {
    value: '4.4',
    label: 'Average Rating',
    sub: 'App Store & Play Store',
    suffix: '',
    prefix: ''
  },
  {
    value: '900',
    label: 'Active Players',
    sub: 'Monthly active users',
    suffix: 'K',
    prefix: ''
  },
  {
    value: '14',
    label: 'Games Released',
    sub: 'Award-winning titles',
    suffix: '+',
    prefix: ''
  }
]

export const Navlinks = [
  { name: 'Home', href: '#home' },
  { name: 'Games', href: '#games' },
  { name: 'Blog', href: '#blog' },
  { name: 'Join Us', href: '#joinus' },
  { name: 'Contact', href: '#contact' },
  { name: 'Career', href: '/career' }
]

export const cardData = [
  {
    new: false,
    title: '29 King',
    downloads: '2M+',
    rating: '4.5',
    link: 'https://play.google.com/store/apps/details?id=com.vipgames.twentynine',
    img: '/games/29king.webp'
  },
  {
    new: false,
    title: 'Card Adda',
    downloads: '1.5M+',
    rating: '4.4',
    link: 'https://play.google.com/store/apps/details?id=com.livegames.cardgames',
    img: '/games/cardAdda.webp'
  },
  {
    new: false,
    title: 'Hazari Royal',
    downloads: '100K+',
    rating: '4.4',
    link: 'https://play.google.com/store/apps/details?id=com.vipgames.Hazariroyal',
    img: '/games/hazariRoyal.webp'
  },
  {
    new: false,
    title: 'Board Adda',
    downloads: '100K+',
    rating: '4.1',
    link: 'https://play.google.com/store/apps/details?id=com.livegames.boardgames',
    img: '/games/boardAdda.webp'
  },
  {
    new: true,
    title: 'Truco',
    downloads: '10K+',
    rating: '4.5',
    link: 'https://play.google.com/store/apps/details?id=com.playboom.trucooffline',
    img: '/games/truco.webp'
  },
  {
    new: true,
    title: 'Tongits',
    downloads: '100K+',
    rating: '4.4',
    link: 'https://play.google.com/store/apps/details?id=com.playboom.tongitsking',
    img: '/games/tongitsKing.webp'
  },
  {
    new: true,
    title: 'Pusoy',
    downloads: '100K+',
    rating: '4.5',
    link: 'https://play.google.com/store/apps/details?id=com.playboom.pusoyking',
    img: '/games/pusoyKing.webp'
  },
  {
    new: true,
    title: 'Adda',
    downloads: '500K+',
    rating: '4.4',
    link: 'https://play.google.com/store/apps/details?id=com.livegames.twentyninecallbreak',
    img: '/games/addaAll.webp'
  }
]

export const jobOpenings = [
  {
    title: 'Junior Unity Game Developer (L1)',
    position: 'Developer',
    requirements: [
      '1+ years of proven professional experience as a Unity game developer.',
      'Must have a good understanding of Unity and C#.',
      'Great problem-solving capability.',
      'Good knowledge of Data Structure and Algorithms.'
    ],
    goodToHave: [
      'If you are someone who plays a lot of casual/puzzle/card/board games, that would be a plus.',
      'If you have live games on Play Store/Apple Store that would be a plus but not necessary.',
      'Excellent English communication and writing skills',
      'Passion for games'
    ]
  },
  {
    title: 'Unity Game Developer (L2)',
    position: 'Developer',
    goodToHave: [
      'You are someone who plays a lot of casual/puzzle/card/board games, that would be a plus.',
      'Have live games on Play Store that would be a plus but not necessary.',
      'Good knowledge of shaders, skeleton animations, multiplayer networking, and editor scripting.',
      'Excellent English communication and writing skills.',
      'Passion for games.'
    ],
    requirements: [
      '2+ years of proven professional experience as a Unity game developer.',
      'Must have a great understanding of C#, Unity APIs, and Version Control (Git).',
      'Understanding of various game programming architectures/patterns.',
      'Good knowledge of Data Structure and Algorithms.',
      'Great problem-solving capability.',
      'Experience integrating 3rd party SDKs like PlayFab/Firebase/AdMob etc.'
    ]
  },
  {
    title: 'Junior Game QA Engineer (L1)',
    position: 'QA',
    goodToHave: [
      'You are someone who plays a lot of casual/puzzle/card/board games, that would be a plus.',
      'Excellent English communication and writing skills.',
      'Passion for games.'
    ],
    requirements: [
      'Bachelor’s degree or equivalent experience.',
      'Understanding of testing procedures and methods.',
      'Ability to adopt and learn new games fast.',
      'Good knowledge of basic Android devices.',
      'Good time management, organizational and analytical skills.',
      'Familiarity with bug tracking tools and processes.'
    ]
  },
  {
    title: 'Junior Game Artist (2D/UI)',
    position: 'Artist',
    requirements: [
      'Must have a good understanding of Illustrator and Photoshop.',
      'Exceptional understanding of character design, color theory, composition, lighting, graphic design and text treatments.',
      'Ability to follow direction, learn, expand talents and skill sets. '
    ],
    goodToHave: [
      'If you are someone who plays a lot of casual/puzzle/card/board games, that would be a plus.',
      '1+ years of experience creating art for mobile games would be a plus but not necessary.',
      'Experience using AI tools is a plus.',
      'Excellent English communication and writing skills.',
      'Passion for games.'
    ]
  }
]

export const joinusCardData = [
  {
    title: 'Create Memorable Games',
    desc: 'We build experiences that players enjoy for long periods of time.',
    img: '/creategames.lottie'
  },
  {
    title: 'Work from Anywhere',
    desc: 'Bring your creativity from anywhere in the world.',
    img: '/workanywhere.lottie'
  },
  {
    title: 'Supportive Community',
    desc: 'Join a team that values curiosity and respect.',
    img: '/community.lottie'
  },
  {
    title: 'Grow Together',
    desc: 'Collaborate with peers who care about craft.',
    img: 'growth.lottie'
  }
]
